import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { Subject, takeUntil } from 'rxjs';
import { EditMapOthersComponent } from './edit-map-others/edit-map-others.component';

@Component({
  selector: 'app-map-others',
  templateUrl: './map-others.component.html',
  styleUrls: ['./map-others.component.scss'],
})
export class MapOthersComponent implements OnInit, OnDestroy, OnChanges {
  @Input() filter: string = '';
  @Input() isAdmin: boolean = false;

  public mapOthersList: any[] = [];
  public isLoading: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadMapOthers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reload when filter changes
    if (changes['filter'] && this.filter && !changes['filter'].firstChange) {
      this.loadMapOthers();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadMapOthers(): void {
    if (!this.filter) {
      return;
    }

    this.isLoading = true;
    this.customerService
      .getMapOthers({ filter: this.filter })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.mapOthersList = response.body || [];
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading map others:', error);
          this.mapOthersList = [];
          this.isLoading = false;
          this.toastr.error('Failed to load items');
          this.cdr.detectChanges();
        },
      });
  }

  openAddModal(): void {
    const modalRef = this.modalService.open(EditMapOthersComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance = modalRef.componentInstance;
    componentInstance.filter = this.filter;
    componentInstance.isEditMode = false;

    componentInstance.saved.subscribe(() => {
      this.loadMapOthers();
    });
  }

  openEditModal(item: any): void {
    const modalRef = this.modalService.open(EditMapOthersComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance = modalRef.componentInstance;
    componentInstance.filter = this.filter;
    componentInstance.isEditMode = true;
    componentInstance.item = {
      id: item.id,
      title: item.title,
      description: item.description,
      icon: item.icon,
    };

    componentInstance.saved.subscribe(() => {
      this.loadMapOthers();
    });
  }

  deleteItem(item: any): void {
    this.local
      .confirmYesNo({
        title: 'Delete Item',
        text: 'Are you sure you want to delete this item?',
        icon: 'warning',
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.customerService.deleteMapOthers(item.id).subscribe({
            next: () => {
              this.toastr.success('Item deleted successfully');
              this.loadMapOthers();
            },
            error: (error) => {
              console.error('Error deleting item:', error);
              this.toastr.error('Failed to delete item');
            },
          });
        }
      });
  }
}

